import React from "react";
import JsBarcode from "jsbarcode";

export const scannableCardPrintStyle = '@media print { body { -webkit-print-color-adjust: exact; margin: 0; padding: 0; } @page { size: 4in 2in; margin: 0; }}';

export default class ScannableCard extends React.Component {
	constructor(props) {
		super(props);

		this.svgRef = React.createRef();
		this.state = {
			renderError: false,
		};
	}

	componentDidMount() {
		this.renderBarcode();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.barcode !== this.props.barcode) {
			this.renderBarcode();
		}
	}

	renderBarcode = () => {
		if (!this.svgRef.current || !this.props.barcode) {
			return;
		}

		try {
			JsBarcode(this.svgRef.current, this.props.barcode, {
				format: "CODE128",
				lineColor: "#000000",
				width: this.props.compact ? 3.6 : 4.6,
				height: this.props.compact ? 42 : 92,
				displayValue: true,
				font: "Arial",
				fontSize: this.props.compact ? 11 : 18,
				margin: this.props.compact ? 0 : 4,
			});
			this.svgRef.current.setAttribute("shape-rendering", "crispEdges");
			if (this.state.renderError) {
				this.setState({renderError: false});
			}
		} catch (error) {
			if (!this.state.renderError) {
				this.setState({renderError: true});
			}
		}
	};

	render() {
		const {barcode, compact, detail, name, title} = this.props;
		const width = compact ? (this.props.compactWidth || 340) : "4in";
		const height = compact ? 72 : "2in";

		return (
			<div style={{backgroundColor: "white", color: "black", display: "inline-block"}}>
				<div style={{
					width,
					minHeight: height,
					textAlign: "center",
					padding: compact ? 0 : "0.08in",
					fontFamily: "Arial, sans-serif",
					boxSizing: "border-box",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}>
					{!compact && title ?
						<div style={{fontSize: 18, fontWeight: "bold", marginBottom: 4, width: "100%"}}>
							{title}
						</div>
						: null}
					{!compact && name ?
						<div style={{fontSize: 14, marginBottom: detail ? 2 : 6, width: "100%"}}>
							{name}
						</div>
						: null}
					{!compact && detail ?
						<div style={{fontSize: 11, marginBottom: 4, width: "100%"}}>
							{detail}
						</div>
						: null}
					{this.state.renderError
						? <div style={{fontSize: 12}}>Unable to render barcode: {barcode}</div>
						: <svg ref={this.svgRef} style={{maxWidth: "100%", height: "auto", shapeRendering: "crispEdges"}}/>}
				</div>
			</div>
		);
	}
}
